import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '@app/utility/api.service'
import { UtilService } from '@app/utility/util.service'
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare var $: any, moment: any

@Component({
  selector: 'app-shared-case',
  templateUrl: './shared-case.component.html',
  styleUrls: ['./shared-case.component.scss']
})
export class SharedCaseComponent implements OnInit {

  caseID = ""
  caseTicket = ""

  sharedHigh = 0
  sharedMedium = 0
  sharedLow = 0
  allHigh = 0
  allMedium = 0
  allLow = 0

  sharedCaseList: any = []
  allCaseList: any = []

  caseStatusList: any

  caseTypeList: any
  subTypeTmpList: any

  caseSubTypeSharedList: any = []
  caseSubTypeAllList: any = []

  subTypeDetailTmpList: any

  caseSubTypeDetailSharedList: any = []
  caseSubTypeDetailAllList: any = []

  caseNoShared: string = ""
  firstnameShared: string = ""
  lastnameShared: string = ""
  telephoneShared: string = ""
  caseTypeShared: string = ""
  caseSubTypeShared: string = ""
  subTypeDetailShared: string = ""
  statusShared: string = ""

  caseTypeMy: string = ""
  caseSubTypeMy: string = ""
  subTypeDetailMy: string = ""
  statusMy: string = ""

  caseNoAll: string = ""
  firstnameAll: string = ""
  lastnameAll: string = ""
  telephoneAll: string = ""
  caseTypeAll: string = ""
  caseSubTypeAll: string = ""
  subTypeDetailAll: string = ""
  statusAll: string = ""

  dtSharedCase: any = null
  dtAllCase: any = null

  role: any = {}
  cookieData: any

  constructor(
    private router: Router,
    private apiService: ApiService,
    private util: UtilService
  ) { }

  async ngOnInit() {
    let thisTs = this
    this.util.ShowWaiting(true)
    this.util.InitValidation()

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    //this.role = JSON.parse(localStorage.getItem("role"))

    //await this.callApi()
    this.callApi()

    $('#dateFromShared').on('changeDate', function (ev:any) {
      $('#dateToShared').datepicker('setStartDate', ev.date);
    });
    $('#dateToShared').on('changeDate', function (ev:any) {
      $('#dateFromShared').datepicker('setEndDate', ev.date);
    });
    $('#dateFromAll').on('changeDate', function (ev:any) {
      $('#dateToAll').datepicker('setStartDate', ev.date);
    });
    $('#dateToAll').on('changeDate', function (ev:any) {
      $('#dateFromAll').datepicker('setEndDate', ev.date);
    });

    this.util.ShowWaiting(false)
  }

  callApi() {
    let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
    let allPara = ""

    if (this.role.dpa_list_allcase) {
      allPara = "case_date_from=" + tmpDate
    }

    Observable.forkJoin(
      this.apiService.get("master", "caseStatus"),
      this.apiService.get("master", "caseType"),
      this.apiService.get("master", "caseSubType"),
      this.apiService.get("master", "caseSubTypeDetail"),
      this.apiService.get("crmservice", "caseIncident", allPara)
    ).subscribe(
      data => {
        this.caseStatusList = data[0]
        this.caseTypeList = data[1]
        this.subTypeTmpList = data[2]
        this.subTypeDetailTmpList = data[3]
        this.allCaseList = data[4]

        this.BindCase()
        this.util.ShowWaiting(false)
      },
      err => {
        console.error(err)
        this.util.ShowWaiting(false)
      }
    );

  }

  async BindCase() {
    this.allHigh = this.allMedium = this.allLow = 0
    
      this.allCaseList.forEach((c: any) => {
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.allHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.allMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.allLow++
          }
        }
      });

      for(var i = 0; i < this.allCaseList.length; i++)
    {
      let order;let orderpri
      if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (this.allCaseList[i].dpa_caseseverityidname != null)  
      {
        if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      this.allCaseList[i].ordercase = order ;
      this.allCaseList[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


    try
    {
         /* this.allCaseList.sort(
            (firstObject: any, secondObject: any) =>
              (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                  (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                    (firstObject.orderpri == secondObject.orderpri ) ? (
                      (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                        (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? ( 
                              (firstObject.ordercase  > secondObject.ordercase ) ? 1 : 
                      -1 )
                      :-1
                    -1 )
                    :-1
                -1 )
              : -1
            ); 

            */
            this.allCaseList.sort((firstObject: any, secondObject: any) => (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
              || firstObject.orderpri - secondObject.orderpri  
              || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
              || firstObject.ordercase - secondObject.ordercase  
              ));
      }
      catch
      {

      } 

    this.drawTableAllCase()
  }

  async searchSharedCase(getAll: boolean = false) {

    this.sharedHigh = this.sharedMedium = this.sharedLow = 0
    if (!this.role.dpa_list_sharecase) {
      return
    }
    //this.util.ShowWaiting(true)

    $('#tbSharedCase').DataTable().clear().destroy();

    let filterd: any = []

    if (getAll) {
      let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
      filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
    }
    else {
      let para = ""
      let fromDtShared = $('#dateFromShared').val();
      let toDtShared = $('#dateToShared').val();

      if (this.caseNoShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoShared
      }
      if (this.firstnameShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameShared
      }
      if (this.lastnameShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameShared
      }
      if (this.telephoneShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneShared
      }


      if (this.caseTypeShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeShared
      }
      if (this.caseSubTypeShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeShared
      }
      if (this.subTypeDetailShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailShared
      }
      if (this.statusShared.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusShared
      }


      if (fromDtShared != null && fromDtShared != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (toDtShared != null && toDtShared != "") {
        para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtShared, true), "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      if (para.length > 0) {
        filterd = await this.apiService.get("crmservice", "caseIncident", para)
      }
      else {
        let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
        filterd = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
      }
    }
    let tmp : any = []
    filterd.forEach((c: any) => {
      if (c.dpa_caseowner == null && c.dpa_casestatuscode == "01") {
        tmp.push(c)
        if (c.dpa_caseseverityidname != null) {
          if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
            this.sharedHigh++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
            this.sharedMedium++
          }
          else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
            this.sharedLow++
          }
        }
      }
    });

    
    
    for(var i = 0; i <  tmp.length; i++)
    {
      let order;let orderpri
      if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(tmp[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (tmp[i].dpa_caseseverityidname != null)  
      {
        if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (tmp[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      tmp[i].ordercase = order ;
      tmp[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


    try
    {
      /*
          this.allCaseList.sort(
            (firstObject: any, secondObject: any) =>
              (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(firstObject.dpa_slatime.substring(0, 10))) ? (
                  (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                    (firstObject.orderpri == secondObject.orderpri ) ? (
                      (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                        (new Date(firstObject.createdon.substring(0, 10))== new Date(firstObject.createdon.substring(0, 10))) ? ( 
                              (firstObject.ordercase  > secondObject.ordercase ) ? 1 : 
                      -1 )
                      :-1
                    -1 )
                    :-1
                -1 )
              : -1
            ); 
            */

            
            tmp.sort((firstObject: any, secondObject: any) => (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
              || firstObject.orderpri - secondObject.orderpri  
              || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
              || firstObject.ordercase - secondObject.ordercase  
              ));
      }
      catch
      {

      }

    this.sharedCaseList = tmp

    this.drawTableSharedCase()
    //this.util.ShowWaiting(false)
  }

  async searchAllCase() {
    this.allHigh = this.allMedium = this.allLow = 0
    if (!this.role.dpa_list_allcase) {
      return
    }
    //this.util.ShowWaiting(true)

    $('#tbAllCase').DataTable().clear().destroy();

    let para = ""

    let fromDtAll = $('#dateFromAll').val();
    let toDtAll = $('#dateToAll').val();

    if (this.caseNoAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "caseno=" + this.caseNoAll
    }
    if (this.firstnameAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameAll
    }
    if (this.lastnameAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameAll
    }
    if (this.telephoneAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "telephone=" + this.telephoneAll
    }

    if (this.caseTypeAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casetypeid=" + this.caseTypeAll
    }
    if (this.caseSubTypeAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casesubtypeid=" + this.caseSubTypeAll
    }
    if (this.subTypeDetailAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casesubtypedetailid=" + this.subTypeDetailAll
    }
    if (this.statusAll.trim() != "") {
      para += (para.length > 0 ? "&" : "") + "casestatusid=" + this.statusAll
    }


    if (fromDtAll != null && fromDtAll != "") {
      para += (para.length > 0 ? "&" : "") + "case_date_from=" + moment(this.util.ConvertToAD(fromDtAll, true), "DD/MM/YYYY").format("YYYY-MM-DD")
    }

    if (toDtAll != null && toDtAll != "") {
      para += (para.length > 0 ? "&" : "") + "case_date_to=" + moment(this.util.ConvertToAD(toDtAll, true), "DD/MM/YYYY").format("YYYY-MM-DD")
    }


    if (para.length > 0) {
      this.allCaseList = await this.apiService.get("crmservice", "caseIncident", para)
    }
    else {
      let tmpDate = moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format("YYYY-MM-DD")
      this.allCaseList = await this.apiService.get("crmservice", "caseIncident", "case_date_from=" + tmpDate)
    }

    this.allCaseList.forEach((c: any) => {
      if (c.dpa_caseseverityidname != null) {
        if (c.dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          this.allHigh++
        }
        else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          this.allMedium++
        }
        else if (c.dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          this.allLow++
        }
      }
    });


    
    for(var i = 0; i < this.allCaseList.length; i++)
    {
      let order;let orderpri
      if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "inprogress")
      {
        order = 1;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "on hold")
      {
        order = 2;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "new")
      {
        order = 3;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "resolved")
      {
        order = 4;
      }
      else if(this.allCaseList[i].dpa_casestatusidname.toLocaleLowerCase() == "cancel")
      {
        order = 5;
      }
      else
      {
        order = 6;
      }

      if (this.allCaseList[i].dpa_caseseverityidname != null)  
      {
        if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "high") {
          orderpri = 1;
        }
        else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "medium") {
          orderpri = 2;
        }
        else if (this.allCaseList[i].dpa_caseseverityidname.toLocaleLowerCase() == "low") {
          orderpri = 3;
        } 
        else {
          orderpri = 4;
        }
      }
      else 
      {
        orderpri = 4;
      }
  

      this.allCaseList[i].ordercase = order ;
      this.allCaseList[i].orderpri = orderpri ;

    }
   // tmp = tmp.map((obj: any) => (Object.assign(obj,{ordercase : if (obj.dpa_casestatusidname)  )));


    try
    {
         /* this.allCaseList.sort(
            (firstObject: any, secondObject: any) =>
              (new Date(firstObject.dpa_slatime.substring(0, 10)) < new Date(secondObject.dpa_slatime.substring(0, 10))) ? 1 :
                (new Date(firstObject.dpa_slatime.substring(0, 10)) == new Date(secondObject.dpa_slatime.substring(0, 10))) ? (
                  (firstObject.orderpri < secondObject.orderpri ) ? 1 :
                    (firstObject.orderpri == secondObject.orderpri ) ? (
                      (new Date(firstObject.createdon.substring(0, 10)) < new Date(secondObject.createdon.substring(0, 10))) ? 1 :
                        (new Date(firstObject.createdon.substring(0, 10)) == new Date(secondObject.createdon.substring(0, 10))) ? ( 
                              (firstObject.ordercase  > secondObject.ordercase ) ? 1 : 
                      -1 )
                      :-1
                    -1 )
                    :-1
                -1 )
              : -1
            ); 

            */
            this.allCaseList.sort((firstObject: any, secondObject: any) => (new Date(firstObject.dpa_slatime.substring(0, 10)).getTime() - new Date(secondObject.dpa_slatime.substring(0, 10)).getTime()
              || firstObject.orderpri - secondObject.orderpri  
              || new Date(firstObject.createdon.substring(0, 10)).getTime() - new Date(secondObject.createdon.substring(0, 10)).getTime()
              || firstObject.ordercase - secondObject.ordercase  
              ));
      }
      catch
      {

      }



    this.drawTableAllCase()
    //this.util.ShowWaiting(false)
  }

  resetSearchSharedCase() {
    this.caseNoShared = ""
    this.firstnameShared = ""
    this.lastnameShared = ""
    this.telephoneShared = ""

    this.caseTypeShared = ""
    this.caseSubTypeShared = ""
    this.subTypeDetailShared = ""
    this.statusShared = ""

    this.caseSubTypeSharedList = []
    this.caseSubTypeDetailSharedList = []

    $('#dateFromShared').val("").datepicker("update");
    $('#dateToShared').val("").datepicker("update");
  }

  resetSearchAllCase() {
    this.caseNoAll = ""
    this.firstnameAll = ""
    this.lastnameAll = ""
    this.telephoneAll = ""

    this.caseTypeAll = ""
    this.caseSubTypeAll = ""
    this.subTypeDetailAll = ""
    this.statusAll = ""

    this.caseSubTypeAllList = []
    this.caseSubTypeDetailAllList = []

    $('#dateFromAll').val("").datepicker("update");
    $('#dateToAll').val("").datepicker("update");
  }

  // ngAfterViewInit() {
  //   this.tbShared.changes.subscribe(t => {
  //     this.initTableShared()
  //   })
  //   this.tbAll.changes.subscribe(t => {
  //     this.initTableAll()
  //   })
  // }

  // ngForRendred() {
  //   console.log('NgFor is Rendered');
  //   if (this.dtAllCase == null) {
  //     this.initTableAll()
  //   }
  //   if (this.dtSharedCase == null) {
  //     this.initTableShared()
  //   }
  // }

  initTableShared() {
    let thisTs = this

    $("#tbSharedCase tbody tr").on("click", function () {

      thisTs.caseID = $(this)[0].id
      thisTs.caseTicket = $(this).find(".col-id")[0].innerText

      $("#takeCaseModal").modal("show")

    });
    this.dtSharedCase = $("#tbSharedCase").dataTable({
      retrieve: true,
      'searching': false,
      order: [],
      "drawCallback": function (settings: any) {
        console.log('DataTables shared has redrawn the table');
      }
    });
  }

  initTableAll() {
    let thisTs = this
    $("#tbAllCase tbody tr").on("click", function () {

      let ids = $(this).find(".col-id")

      const url = thisTs.util.baseUrl() + `/caseDetail/` + ids[0].innerText

      window.open(url, '_blank');
    });

    this.dtAllCase = $("#tbAllCase").dataTable({
      retrieve: true,
      'searching': false,
      order: [],
      "drawCallback": function (settings: any) {
        console.log('DataTables all has redrawn the table');
      }
    });
  }

  async takeCase() {
    this.util.ShowWaiting(true)

    let req = this.sharedCaseList.filter((c:any) =>{
      return c.incidentid == this.caseID
    })

    req[0]["dpa_modifiedby"] = this.cookieData.userId
    req[0]["dpa_caseowner"] = this.cookieData.userId

    let res: any = await this.apiService.put("crmservice", "caseIncident-takeOwner/" + this.caseID, req[0])

    if (this.util.isSuccessResponse(res)) {
      await this.searchSharedCase(true)
      $("#takeCaseModal").modal("hide")
      this.util.ShowWaiting(false)
      this.util.SuccessDialog("รับเคสสำเร็จ")

      setTimeout(() => {
        const url = this.util.baseUrl() + `/caseDetail/` + this.caseTicket
        window.open(url, '_blank');
      }, 800);
    }
    else {
      this.util.ShowWaiting(false)
      this.util.ErrorDialog("รับเคสไม่สำเร็จ")
    }
  }

  onCaseTypeAllChange() {
    if (this.caseTypeAll != null && this.caseTypeAll.length > 0) {
      this.caseSubTypeAllList = this.subTypeTmpList.filter(
        (subType: any) => subType.dpa_casetypeid === this.caseTypeAll)
    }
  }

  onCaseSubTypeAllChange() {
    if (this.caseSubTypeAll != null && this.caseSubTypeAll.length > 0) {
      this.caseSubTypeDetailAllList = this.subTypeDetailTmpList.filter(
        (subType: any) => subType.dpa_casesubtypeid === this.caseSubTypeAll)
    }
  }

  onCaseTypeSharedChange() {
    if (this.caseTypeShared != null && this.caseTypeShared.length > 0) {
      this.caseSubTypeSharedList = this.subTypeTmpList.filter(
        (subType: any) => subType.dpa_casetypeid === this.caseTypeShared)
    }
  }

  onCaseSubTypeSharedChange() {
    if (this.caseSubTypeShared != null && this.caseSubTypeShared.length > 0) {
      this.caseSubTypeDetailSharedList = this.subTypeDetailTmpList.filter(
        (subType: any) => subType.dpa_casesubtypeid === this.caseSubTypeShared)
    }
  }

  drawTableSharedCase(){
    $("#tbSharedCase tbody").empty()
    this.sharedCaseList.forEach((c: any) => {
      let priority = ""
      let tr = ""

      if(c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == ""){
        tr += '<tr id="'  + c.incidentid + '">' +
        '<td align="center"></td>'
      }
      else{
        let severity = c.dpa_caseseverityidname.toLowerCase()
        if(severity == "high"){
          priority = "3"
        }
        else if(severity == "medium"){
          priority = "2"
        }
        else if(severity == "low"){
          priority = "1"
        }

        tr += '<tr id="'  + c.incidentid + '">' +
        '<td align="center" data-sort="' + priority + '">' +
          '<span class="dot ' + severity +'"></span>' +
        '</td>'
      }

      tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
      '<td>' + c.dpa_casesubtypeidname + '</td>' +
      '<td>' + c.customeridname + '</td>' +
      '<td>' + c.dpa_casechannelidname + '</td>' +
      '<td>' + c.dpa_casestatusidname + '</td>' +
      '<td><span class="sr-only">' + this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' + 
        this.util.transformDate(c.createdon, 'shortWithTime') + '</td>'
      if(c.dpa_issla){
        tr += '<td align="center" class="high">Over</td>'
      }
      else {
        if(c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())){
          tr += '<td align="center" class="low">Warning</td>'
        }
        else{
          tr += '<td align="center" class="high"></td>'
        }
      }
      tr += '<td><span class="sr-only">' + this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>' 
      + this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
    '</tr>'
      $("#tbSharedCase tbody").append(tr);
    });

    this.initTableShared()
  }

  drawTableAllCase(){
    $("#tbAllCase tbody").empty()
    this.allCaseList.forEach((c: any) => {
      let priority = ""
      let tr = ""

      if(c.dpa_caseseverityidname == null || c.dpa_caseseverityidname.trim() == ""){
        tr += '<tr id="'  + c.incidentid + '">' +
        '<td align="center"></td>'
      }
      else{
        let severity = c.dpa_caseseverityidname.toLowerCase()
        if(severity == "high"){
          priority = "3"
        }
        else if(severity == "medium"){
          priority = "2"
        }
        else if(severity == "low"){
          priority = "1"
        }

        tr += '<tr id="'  + c.incidentid + '">' +
        '<td align="center" data-sort="' + priority + '">' +
          '<span class="dot ' + severity +'"></span>' +
        '</td>'
      }

      let statusName: string = ""
      if(c.dpa_casestatusidname){
        statusName = c.dpa_casestatusidname
      }

      tr += '<td class="col-id">' + c.ticketnumber + '</td>' +
      '<td>' + c.dpa_casesubtypeidname + '</td>' +
      '<td>' + c.customeridname + '</td>' +
      '<td>' + c.dpa_casechannelidname + '</td>' +
      '<td>' + statusName + '</td>' +
      '<td><span class="sr-only">' + this.util.transformDate(c.createdon, 'fullWithoutDelimeter') + '</span>' + 
        this.util.transformDate(c.createdon, 'shortWithTime') + '</td>'
      if(c.dpa_issla){
        tr += '<td align="center" class="high">Over</td>'
      }
      else {
        if(c.dpa_warningtime != null && c.dpa_warningtime != "" && (moment(c.dpa_warningtime.replace("Z", "")) <= moment())){
          tr += '<td align="center" class="low">Warning</td>'
        }
        else{
          tr += '<td align="center" class="high"></td>'
        }
      }
      tr += '<td><span class="sr-only">' + this.util.transformDate(c.dpa_slatime, 'fullWithoutDelimeter') + '</span>' 
      + this.util.transformDate(c.dpa_slatime, 'shortWithTime') + '</td>' +
    '</tr>'
      $("#tbAllCase tbody").append(tr);
    });

    this.initTableAll()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-case/shared-case.component.ts